import { CheckIcon, XIcon } from '@heroicons/react/solid';

interface YesNoIndicatorProps {
  value?: string | null;
}

export const YesNoIndicator = ({ value }: YesNoIndicatorProps) => {
  if (value === 'true') {
    return (
      <>
        <CheckIcon className="size-4 text-zinc-700" aria-hidden="true" />
        <span className="sr-only">Yes</span>
      </>
    );
  } else if (value === 'false') {
    return (
      <>
        <XIcon className="size-4 text-zinc-600" aria-hidden="true" />
        <span className="sr-only">No</span>
      </>
    );
  }

  return '--';
};
